<template>
    <v-container class="pa-2">
 <template>
    <v-card class="mt-0">
    <v-card-title>
          <h4 class="subheading grey--text">Φίλτρα</h4>
          <v-spacer/>
        <v-btn
        icon
        @click="showFilters = !showFilters"
      >
        <v-icon>{{ showFilters ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
      </v-btn>
        </v-card-title>
     <v-expand-transition>
      <div v-show="showFilters">

       <v-card-text>
          <v-row>
            <v-col cols="12" sm="4">
            <v-select
                v-model="invoicingPeriod"
                :items="uniqueInvoiceYears"
                :suffix="fiDate"
                label="Έτος χρήσης"
                prepend-icon="mdi-calendar"
                clearable
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
      </div>
    </v-expand-transition>
    </v-card>
    </template>
    
  <template>
  <v-card class="mt-4"
    :loading="loading"
    >
    <v-card-title>
       <h1 class="mr-2 subheading grey--text">Τιμολόγια</h1>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="invoices"
      :search="search"
      loading: false
      item-key="InvoiceId"
      sort-by="Date"
      sort-desc
      class="elevation-1"
      :loading="loading"
      loading-text="Loading... Please wait"
      single-expand: true
      :expanded.sync="expanded"
      show-expand
      @current-items="getFilteredInvoices"
    >

     <template v-slot:item.actions="{ item }">
        <v-btn
          icon
          @click.stop="showdialog(item)"
        >
         <v-icon>mdi-information-variant</v-icon>
        </v-btn>
         <v-btn
          icon
          @click.stop="createInvoice(item)"
        >
         <v-icon>mdi-content-copy</v-icon>
        </v-btn>
     </template>

     <template v-slot:item.NetValue="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.NetValue) }}
    </template>
    <template v-slot:item.TotalValue="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.TotalValue) }}
    </template>
    <template v-slot:item.VatValue="{ item }">
       {{ new Intl.NumberFormat('el-GR', { style: 'currency', currency: 'EUR' }).format(item.VatValue) }}
    </template>
     <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        More info about {{ item.DocNumber }}
      </td>
    </template>

   <template v-slot:body.append="{headers}">
        <tr>
            <td v-for="(header,i) in headers" :key="i">

                <div class="text-right" v-if="header.value == 'TotalValue'">
                    Σύνολο: {{ $tocurr($sumField(filteredInvoices, 'TotalValue')) }}
                </div>

                <div v-else>
                    <!-- empty table cells for columns that don't need a sum -->
                </div>

            </td>
        </tr>
    </template>

    </v-data-table>
  </v-card>
</template>
  <v-snackbar
   timeout=2500
   v-model="snackbar"
   multi-line=true>
      {{ snackText }}
  </v-snackbar>

    </v-container>
  
</template>

<script>
import { clone as _clone } from 'lodash'

export default {
  computed: {
   uniqueInvoiceYears () {
      // console.log("asdsd: ", this.uniq(this.invoices, "PlateNumber"));
      return this.uniqYears(this.invoices);
    },
    fi() {
      if (!this.mark) return;
      return this.tocurr(this.sumField(this.filteredInvoices, 'TotalValue'))
    },
    fiDate() {
      if (!this.invoicingPeriod) return;
      return this.tocurr(this.sumField(this.filteredInvoices, 'TotalValue'))
    },
  },
  data() {
    return {
      expanded: [],
      snackbar: false,
      snackText: "",
      timdialog: false,
      diaitems: {},
      loading: true,
      balance: 0.0,
      search: '',
      sid: this.$route.params.id,
      invoices: [],
      filteredInvoices: [],
      invoicingPeriod: '',
      showFilters: true,
      invoiceForm: {
            SeriesCode: '',
            DocNumber: 0,
            InvoiceType: '1.1',
            Date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            Remarks: null,
            PaymTerm: 5,
            NetValue: 0,
            VatValue: 0,
            TotalValue: 0,
            Kind: 0
      },
      headers: [
          {
            text: 'Αρ. Τιμολογίου',
            align: 'start',
            //sortable: false,
            value: 'Id',
            width: '5%',
          },
           { text: 'Ημερομηνία', value: 'Date', width: '10%',
          filter: (value) => {
            if (!this.invoicingPeriod) return true;
            if (this.invoicingPeriod == value.slice(0,4)) return true;
            },
          
           },
          { text: 'Τυπος', value: 'InvoiceType' },
          { text: 'Σειρά', value: 'SeriesCode' },
          { text: 'Αριθμός', value: 'DocNumber' },
          { text: 'Καθαρή αξία', value: 'NetValue', align: 'end' },
          { text: 'ΦΠΑ', value: 'VatValue', align: 'end' },
          { text: 'Συνολο', value: 'TotalValue', align: 'end' },
          { text: 'ΑΑΔΕ ΜΑΡΚ', value: 'Mark', align: 'center' },
          { text: 'Actions', value: 'actions' },
          { text: '', value: 'data-table-expand' },
        ],
    }
  },
  async created() {
      try {
        const response = await this.$api.get('/suppliers/'+this.$route.params.id);
        console.log(response);
        this.supplier = response.data;
        this.invoices = this.supplier.AadeInvoices;
        this.loading = false;
      } catch (error) {
        console.error(error);
      }
    },
watch: {
      timdialog (val) {
        val || this.close()
      },
},
  methods: {
  showdialog(item) {
    //console.log(item, this.timdialog)
    this.diaitems = item.line_items;
    this.timdialog = true;
  },
    getFilteredInvoices (invos) {
       this.filteredInvoices = invos;
    },
     uniq(items, key) {
      //Store the unique
      let uniques = [];

      //Track the items added to the uniques
      let itemsFound = {};
      for (let val of items) {
        //If item is already added then move to the next item
        if (itemsFound[val[key]]) {
          continue;
        }

        //Else push it to the unique list
        uniques.push(val[key]);

        //Mark it as added
        itemsFound[val[key]] = true;
      }

      //Return the uniques
      return uniques;
    },
  remove(obj, item) {
    obj.splice(obj.indexOf(item), 1);
    obj.vehicle = [...obj];
  },

    uniqYears(items) {
      //Store the unique
      let uniques = [];

      //Track the items added to the uniques
      let itemsFound = {};
      let year = 0;
      for (let val of items) {
        year = val['Date'].slice(0,4);
        //console.log(year) //.getFullYear();
        //If item is already added then move to the next item
        if (itemsFound[val[year]]) {
          continue;
        }

        //Else push it to the unique list
        uniques.push(year);

        //Mark it as added
        itemsFound[year] = true;
      }

      //Return the uniques
      return uniques;
    },
      tocurr(value) {
      return new Intl.NumberFormat("el-GR", {
        style: "currency",
        currency: "EUR",
      }).format(value);
    },
    sumField(items, key) {
      // sum data in give key (property)
      return items.filter(({InvoiceType}) => InvoiceType === '1.1').reduce((a, b) => a + (b[key] || 0), 0);
    },
    
  async createInvoice(item) {
        let invoice = _clone(this.invoiceForm);
        invoice.PaymTerm = item.PaymTerm;
        invoice.NetValue = item.NetValue;
        invoice.VatValue = item.VatValue;
        invoice.TotalValue = item.TotalValue;
        invoice.SeriesCode = item.SeriesCode;
        invoice.DocNumber = item.DocNumber;
        invoice.InvoiceType = item.InvoiceType;
        invoice.Date = item.Date;
        invoice.Mark = item.Mark;
        var response = await this.$api.post("/suppliers/"+this.$route.params.id+"/invoice/", invoice);
        if (response.status == 201) {
          // this.invoiceForm.Id = response.data.Id;
          this.snackText = `Αντιγραφηκε το τιμολόγιο ${item.SeriesCode}-${item.DocNumber}.\nΝέο υπόλοιπο: ${response.data.Supplier.Balance.toFixed(2)}€`;
          this.snackbar = true;
          
        } else {
          alert(response.data);
        }
      },
  
  close () {
        this.timdialog = false
  }

  }
}
</script>
